<div class="flex w-full gap-4 items-center">
	@for (tab of tabs_(); track tab.value) {
		<div
			class="has-[>_button[aria-selected='true']]:border-green-600 border-b-2 border-transparent py-2"
		>
			<button
				class="flex items-center justify-center gap-2 px-3 py-1 duration-300 aria-selected:text-green-600 group/e-signing-tabs rounded-md hover:bg-gray-200"
				(click)="selectedTab_.set(tab.value)"
				[ariaSelected]="selectedTab_() === tab.value"
				[attr.data-intercom-target]="tab.intercomAttr"
			>
				<i-tabler [name]="tab.icon" class="size-5" />
				<h5 class="h5 mb-0 group-aria-selected/e-signing-tabs:text-green-600">
					{{ tab.label }}
				</h5>
			</button>
		</div>
	}
</div>
